import {
	EndorsementEntityField,
	EndorsementEntityType,
	EndorsementSubmissionStatusReason,
} from '@app/enumerations';

export default class EndorsementSubmissionStatusError {
	public reason: EndorsementSubmissionStatusReason | null = null;
	public entityType: EndorsementEntityType | null = null;
	public fieldAffected: EndorsementEntityField | null = null;
	public entityId: string | null = null;
	public message: string | null = null;
}